// extracted by mini-css-extract-plugin
export var closeButton = "_c9-1";
export var closeX = "_c9-3";
export var container = "_c9-0";
export var image = "_c9-2";